import React from 'react';
import { signOut } from 'firebase/auth';
import logoConnect10 from '../../assets/logo-connect10.png';

/**
 * @file Componente para a página de "Aguardando Aprovação".
 * Exibida para novos usuários cujo acesso ainda não foi liberado por um administrador.
 *
 * @param {object} props - As propriedades do componente.
 * @param {object} props.auth - A instância do serviço de autenticação do Firebase.
 */
const PendingApprovalPage = ({ auth }) => {
    return (
        <div className="w-full min-h-screen bg-slate-100 dark:bg-slate-900 flex items-center justify-center p-4 font-sans">
            <div className="w-full max-w-md p-8 text-center bg-white dark:bg-slate-800 rounded-2xl shadow-2xl">
                <img src={logoConnect10} alt="Logo Connect10" className="h-12 mx-auto mb-6" />
                <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-4">Aguardando Aprovação</h1>
                <p className="text-slate-500 dark:text-slate-400 mb-8">Sua conta foi criada com sucesso e está aguardando a aprovação de um administrador. Você será notificado por e-mail quando seu acesso for liberado.</p>
                <button onClick={() => signOut(auth)} className="w-full bg-blue-600 text-white font-bold py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300">
                    Sair
                </button>
            </div>
        </div>
    );
};

export default PendingApprovalPage;
